import script from "./BlockJMC.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockJMC.vue?vue&type=script&setup=true&lang=js"

import "./BlockJMC.vue?vue&type=style&index=0&id=56d6a14b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1694328059/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d6a14b"]])

export default __exports__